<script>
import reduce from 'lodash/reduce';

const yesOrNo = [
  { value: '', text: 'Please choose', disabled: true, selected: true },
  { value: true, text: 'Yes' },
  { value: false, text: 'No' },
];

export default {
  name: 'OpenQuestionWithAdditionals',
  props: {
    titleNumberOrLetter: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    labelName: {
      type: String,
      required: true,
    },
    dropdownName: {
      type: String,
      required: true,
    },
    additionalDropdownName: {
      type: String,
      required: true,
    },
    textAreaName: {
      type: String,
      required: true,
    },
    validationFieldName: {
      type: String,
      required: true,
    },
    additionalAnswers: {
      type: Object,
      default: () => ({}),
    },
    descriptionTitle: {
      type: String,
      required: false,
    },
    value: {
      type: Object,
      default: () => ({
        answer: '',
        additionalAnswer: null,
        description: null,
      }),
    },
  },
  data() {
    return {
      chosenAnswer: typeof this.value.answer === 'boolean' ? this.value.answer : '',
      chosenAdditionalAnswer: this.value.additionalAnswer != 'ETF_UNSPECIFIED' ? this.value.additionalAnswer : null,
      chosenDescription: this.value.description,
      yesOrNo,
    };
  },
  methods: {
    triggerUpdate() {
      this.$emit('input', {
        answer: this.chosenAnswer === 'true' || this.chosenAnswer,
        additionalAnswer: this.chosenAdditionalAnswer ? this.chosenAdditionalAnswer : '',
        description: this.chosenDescription ? this.chosenDescription : '',
      });
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
  computed: {
    additionalAnswersOptions: function () {
      return reduce(
        this.additionalAnswers,
        (accumulator, value, key) => {
          const option = {
            value: key,
            text: value,
          };
          accumulator.push(option);
          return accumulator;
        },
        [{ value: null, text: 'Please choose', disabled: true, selected: true }],
      );
    },
  },
};
</script>

<template>
  <div>
    <div class="row my-3">
      <div class="col-md-9">
        <div>
          <div v-if="titleNumberOrLetter">
            <div class="row">
              <div class="col-md-1">
                <h5>
                  <label>{{ titleNumberOrLetter }}</label>
                </h5>
              </div>
              <div class="col-md-11">
                <h5>
                  <label :name="labelName" class="mandatory">{{ title }}</label>
                </h5>
              </div>
            </div>
          </div>
          <div v-else>
            <h5>
              <label :name="labelName" class="mandatory">{{ title }}</label>
            </h5>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <validation-provider :name="validationFieldName" rules="required" v-slot="validationContext">
          <b-form-select
            :options="yesOrNo"
            :state="getValidationState(validationContext)"
            aria-describedby="answer-type-error"
            class="form-control bg-white"
            :name="dropdownName"
            v-model="chosenAnswer"
            @change="triggerUpdate"
          ></b-form-select>
          <b-form-invalid-feedback data-error-name="select-error" v-if="validationContext.errors[0]"
            >{{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </validation-provider>
      </div>
    </div>

    <div v-if="descriptionTitle" class="row my-3">
      <div class="col-md-12">
        <h5>
          <label>{{ descriptionTitle }}</label>
        </h5>
      </div>
    </div>

    <div v-if="chosenAnswer" class="row my-3">
      <div class="col-md-9"></div>
      <div class="col-md-3">
        <validation-provider name="supply a copy" rules="required" v-slot="validationContext">
          <b-form-select
            :options="additionalAnswersOptions"
            :state="getValidationState(validationContext)"
            aria-describedby="answer-type-error"
            class="form-control bg-white"
            :name="additionalDropdownName"
            v-model="chosenAdditionalAnswer"
            @change="triggerUpdate"
          ></b-form-select>
          <b-form-invalid-feedback data-error-name="additional-select-error" v-if="validationContext.errors[0]"
            >{{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </validation-provider>
      </div>
    </div>

    <slot></slot>

    <div v-if="chosenAnswer" class="row my-3">
      <div class="col-md-12">
        <validation-provider name="details" rules="required|min:3" v-slot="validationContext">
          <b-form-textarea
            :name="textAreaName"
            v-model="chosenDescription"
            @input="triggerUpdate"
            :id="dropdownName"
            rows="4"
            :state="getValidationState(validationContext)"
          ></b-form-textarea>
          <b-form-invalid-feedback data-error-name="textarea-error" v-if="validationContext.errors[0]"
            >{{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </validation-provider>
      </div>
    </div>
  </div>
</template>
